import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useI18n } from "@/i18n";
import { useDownload } from "@/hooks/useDownload";
import { AiFillApple } from "react-icons/ai";

const Footer = () => {
  const { language } = useI18n();
  const { isLoading, downloadLatest } = useDownload();

  return (
    <footer>
      {/* CTA Block */}
      <div className="py-24 md:py-32 bg-[#111827]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              {language === 'en' ? 'Ready to Run AI Locally?' : '准备好在本地运行 AI 了吗？'}
            </h2>
            <p className="text-lg md:text-xl mb-8 text-gray-400">
              {language === 'en'
                ? 'Download Estha for Mac and take control of your AI.'
                : '下载 Estha for Mac，掌控你的 AI。'}
            </p>

            <Button
              size="lg"
              className="text-base px-8 bg-[#1E88C8] hover:bg-[#1670A8] text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
              onClick={downloadLatest}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 animate-spin" />
                  {language === 'en' ? 'Loading...' : '加载中...'}
                </>
              ) : (
                <>
                  <AiFillApple className="mr-1" />
                  {language === 'en' ? 'Download Estha for Mac' : '下载 Estha for Mac'}
                </>
              )}
            </Button>

            <p className="mt-6 text-sm text-gray-500">
              {language === 'en'
                ? 'Runs on any Mac with Apple Silicon (M2+) · 16GB RAM minimum'
                : '支持所有 Apple Silicon Mac（M2+）· 最低 16GB 内存'}
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="py-8 bg-[#0F172A] border-t border-white/10">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500">
              {language === 'en' ? '© 2026 Estha. All rights reserved.' : '© 2026 Estha. 保留所有权利。'}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-500">
              <a href="https://estha.ai/privacypolicy/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors">
                {language === 'en' ? 'Privacy Policy' : '隐私政策'}
              </a>
              <span className="text-gray-700">·</span>
              <a href="https://estha.ai/tos/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors">
                {language === 'en' ? 'Terms of Service' : '使用条款'}
              </a>
              <span className="text-gray-700">·</span>
              <a href="mailto:eric.lam@estha.ai" className="hover:text-gray-300 transition-colors">
                {language === 'en' ? 'Contact' : '联系我们'} (eric.lam@estha.ai)
              </a>
            </div>
            <div className="flex items-center gap-4 text-sm text-gray-500">
              <a href="https://mac.estha.ai" className="hover:text-gray-300 transition-colors">mac.estha.ai</a>
              <span className="text-gray-700">·</span>
              <a href="https://estha.ai" className="hover:text-gray-300 transition-colors">estha.ai</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
